import React, { useState, useEffect } from 'react';
import { Box, Typography, Divider } from '@mui/material';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import { useNavigate } from 'react-router-dom';

const LoyaltyCard = ({ group }) => {
  const [isHovered, setIsHovered] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/memberships/${group.group_id}`);
  };

  return (
    <Box
      sx={{ cursor: 'pointer', textAlign: 'center' }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={handleClick}
    >
      <Box
        sx={{
          position: 'relative',
          width: 200,
          height: 200,
          m: 2,
          borderRadius: '50%',
          bgcolor: isHovered ? '#1976d2' : '#f5f5f5',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          overflow: 'hidden',
          transition: 'background-color 0.3s ease'
        }}
      >
        {/* Content */}
        <Box
          sx={{
            height: '100%',
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'space-around',
            py: 3,
            px: 2,
            zIndex: 2,
            position: 'relative',
            color: isHovered ? 'white' : 'inherit',
            transition: 'color 0.3s ease'
          }}
        >
          {/* Group logo or coupon icon */}
          {group.group_logo ? (
            <Box
              component="img"
              src={group.group_logo}
              alt={`${group.group_name} logo`}
              sx={{
                width: 80,
                height: 80,
                objectFit: 'contain',
              }}
            />
          ) : (
            <LocalOfferIcon
              sx={{
                width: 50,
                height: 50,
                color: isHovered ? 'white' : '#757575',
                transition: 'color 0.3s ease'
              }}
            />
          )}

          {/* Divider line */}
          <Divider
            sx={{
              width: '80%',
              my: 1,
              borderColor: isHovered ? 'white' : '#bdbdbd',
              transition: 'border-color 0.3s ease'
            }}
          />

          {/* Points display */}
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              height: 80,
              gap: 1
            }}
          >
            <MonetizationOnIcon sx={{ color: 'gold' }} />
            <Typography
              variant="h6"
              component="span"
              sx={{
                fontWeight: 'bold',
                color: isHovered ? 'white' : 'inherit',
                transition: 'color 0.3s ease'
              }}
            >
              {Math.floor(group.current_points).toLocaleString()}
            </Typography>
          </Box>
        </Box>
      </Box>

      <Typography
        variant="h6"
        component="div"
        sx={{
          color: isHovered ? '#1976d2' : 'inherit',
          transition: 'color 0.3s ease'
        }}
      >
        {group.group_name}
      </Typography>
    </Box>
  );
};

export default LoyaltyCard;